import axios from "axios";
import { baseUrl } from "../config/env";

const config = {
    headers: {
        accesstoken: localStorage.getItem("accesstoken")
    }
};

export function createCharge(data) {
    return axios.post(baseUrl + "/checkout/charge", data, config);
}

export function fetchUserCharges() {
    return axios.get(baseUrl + `/checkout/charge/user/list`, config);
}

export function deleteCheckout(id) {
    return axios.get(baseUrl + `/checkout/payments/delete/${id}`, config);
}
